export default __webpack_public_path__ + "static/book2-83160aeb6279fdce49837c76f3bf5fe5.jpg";